import {Component, OnDestroy, OnInit} from '@angular/core';
import {TableService, VisitedService} from "@amlCore/services";
import {Subject} from 'rxjs';
import {takeUntil} from "rxjs/operators";
import {DictionariesService} from "../../../service/dictionaries.service";
import { TableController } from "@amlCore/tableController";
import {Utils} from "@amlCore/utils";
import {QrefBarx} from "../../../../../../api/build";

@Component({
  selector: 'app-dictionary-qref-b-arx',
  templateUrl: './qrefBArx.component.html'
})
export class QrefBArxComponent extends TableController implements OnInit, OnDestroy {
  data: QrefBarx[] = [];
  goBack = Utils.goBack;
  isShowVisited = false;
  isSetFocus = false;

  private destroy$ = new Subject<void>();

  constructor(protected dictSrv: DictionariesService,
              protected visitedService: VisitedService,
              protected tableService: TableService
              ) {
    super(visitedService, tableService);
  }

  ngOnInit() {
    this.loadDict();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadDict() {
    // Данные справочника при последующих вызовах берутся из sessionStorage

    this.dictSrv.getQrefBArxList().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.data = data.content;
    });
  }
  onPageChange(params): void {
    this.loadDict();
  }
}


